module.exports = __webpack_public_path__ + "media/application/images/external-services/ebay-logo-2a9161c00e789d57dcfd41845e9a9f0d.svg";